import { Component, Inject, QueryList, AfterContentInit, ContentChildren } from '@angular/core';
import { IFileStorageService } from 'src/app/core/services/api/contracts/file-storage.service';
import { FileDescriptorComponent, FileDescriptorEvent } from '../file-descriptor/file-descriptor.component';
import { LoadingService, LoadingInstance } from 'src/app/core/services/loading.service';

@Component({
  selector: 'file-container',
  templateUrl: './file-container.component.html',
  styleUrls: ['./file-container.component.scss']
})

export class FileContainerComponent implements AfterContentInit {
  @ContentChildren(FileDescriptorComponent, { descendants: true }) fileDescriptors: QueryList<FileDescriptorComponent>;
  fileStorageBatchId: string;

  fileDescriptorComponents = new Array<FileDescriptorComponent>();

  loadingInstance: LoadingInstance;

  constructor(@Inject('IFileStorageService') private fileStorageService: IFileStorageService,
    private loadingService: LoadingService) {
  }

  ngOnInit() { }

  ngAfterContentInit(): void {
    this.fileDescriptors.changes.subscribe((fdcq: QueryList<FileDescriptorComponent>) => {
      let newComponents = fdcq.toArray().filter(x => !this.fileDescriptorComponents.some(y => y == x));
      if (newComponents && newComponents.length > 0) {
        newComponents.forEach(nc => {
          this.fileDescriptorComponents.push(nc);
          nc.fileChanging.subscribe(() => {
            this.loadingInstance = this.loadingService.startLoading();
            if (this.fileStorageBatchId) {
              nc.setBatchId(this.fileStorageBatchId);
            }
          });
          nc.fileChanged.subscribe((ev) => {
            this.loadingService.stopLoading(this.loadingInstance);
            if (!this.fileStorageBatchId) {
              this.fileStorageBatchId = ev.batchId;
            }
          });
        });
      }
    });

    this.fileDescriptors.forEach(x => {
      this.fileDescriptorComponents.push(x);
      x.fileChanging.subscribe(() => {
        this.loadingInstance = this.loadingService.startLoading();
        if (this.fileStorageBatchId) {
          x.setBatchId(this.fileStorageBatchId);
        }
      });
      x.fileChanged.subscribe(($event: FileDescriptorEvent) => {
        this.loadingService.stopLoading(this.loadingInstance);
        if (!this.fileStorageBatchId) {
          this.fileStorageBatchId = $event.batchId;
        }
      })
    });
  }

  async commitFiles() {
    if (this.fileStorageBatchId) {
      await this.fileStorageService.commit(this.fileStorageBatchId);
    } else {
      return false;
    }
  }
}
